import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'

export default createUIDefinition({
    taskName: taskName.CONSULT_CUSTOMER,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.COMMENT_LIST,
        },
    ],
    overwriteWidget: true,
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/consult-customer.js